import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LegalCounselService } from 'src/app/acl-data/legal-counsel/legal-counsel.service';
import { map, switchMap, take, tap, withLatestFrom } from 'rxjs/operators';
import { DocumentService } from 'src/app/acl-data/document/document.service';
import { Document } from 'src/app/acl-data/document/document.dto';
import { BehaviorSubject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-assign-legal-counsel-dialog',
  templateUrl: './assign-legal-counsel-dialog.component.html',
  styleUrls: ['./assign-legal-counsel-dialog.component.scss']
})
export class AssignLegalCounselDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<AssignLegalCounselDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private legalCounselService: LegalCounselService,
    private documentService: DocumentService,
    private route: ActivatedRoute) { }

  lcSearch = '';
  loading$ = new BehaviorSubject<boolean>(false);

  ngOnInit(): void {
      
  }

  private setLoadingState(loading: boolean): void {
    this.loading$.next(loading)
  }

  onLegalCounselChange = input => {
    this.legalCounselService
            .getByKey(this.data.ContractLegalCounsel)
            /*.pipe(
                tap(v => console.log('onLegalCounselChange() > Legal Counsel', v)),
                take(1)
            )*/
            .subscribe(v => {
                if (!v) {
                    console.error(
                        'Could not find Legal Counsel:',
                        this.data.ContractLegalCounsel
                    );
                } else {
                    //console.log("fullname = " + v["fullname"])
                    this.data.contractLegalCounselName =
                        v["fullname"];
                }
            });
  }

  onCloseClick(): void {
    this.dialogRef.close({
      state: 'Cancelled'
    });
  }

  onAssignClick(): void {
    this.setLoadingState(true)
    let state;
    try {
      var updateDocs = [];
      this.documentService.getByIds(this.data.objectStore, this.data.ids, true, false).subscribe((documents: Document[]) => {
        documents.forEach((doc: Document) => {
          const updateDoc = { ...doc }; 
          updateDoc.propertiesObj = { ...updateDoc.propertiesObj }; 
          updateDoc.propertiesObj.ContractLegalCounsel = this.data.ContractLegalCounsel;
          updateDocs = updateDocs.concat(updateDoc);
        });

        this.documentService.bulkUpdate(updateDocs,this.data.objectStore).subscribe(v => {
          this.documentService.upsertManyInCache(updateDocs);
          state = 'success'
          const result = {
            state: state,
            contractLegalCounselName: this.data.contractLegalCounselName
          };
          this.setLoadingState(false)
          this.dialogRef.close(result);
        }, 
          e => {state = "error"
            
          const result = {
            state: state,
            contractLegalCounselName: this.data.contractLegalCounselName
          };
          this.setLoadingState(false)
          this.dialogRef.close(result);
        })
            
      });
    } catch (error) {
      console.log(error);
      state = "error";
      const result = {
        state: state,
        contractLegalCounselName: this.data.contractLegalCounselName
      };
      this.setLoadingState(false)
      this.dialogRef.close(result);
    }
  }
    
}
